import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/auth/auth-context";

const CARDS = [
  {
    to: "/app/train",
    emoji: "🎯",
    title: "Train",
    body: "Pick a few sets and practise a blended session — or drill your wrongs.",
  },
  {
    to: "/app/create",
    emoji: "✨",
    title: "Create a set",
    body: "Pick a framework and let Eddi generate a tailored question set.",
  },
  {
    to: "/app/library",
    emoji: "📚",
    title: "Library",
    body: "Open your sets, review topics, and practise a single set.",
  },
  {
    to: "/app/community",
    emoji: "👥",
    title: "Community",
    body: "Join clans, share sets, and study together.",
  },
  {
    to: "/app/stats",
    emoji: "📈",
    title: "Statistics",
    body: "Track your progress and explore the global knowledge tree.",
  },
];

export function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const name = user?.display_name || user?.username || t("there");

  return (
    <div className="animate-fade-up">
      <h1 className="text-3xl font-bold tracking-tight">
        {t("Welcome back, {{name}}", { name })} <span className="align-middle">👋</span>
      </h1>
      <p className="mt-1 text-ink-faint">
        {t("Your EduPause account, now on the web. Pick up where you left off.")}
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="card group flex items-start gap-4 p-5 transition hover:-translate-y-0.5 hover:shadow-glow"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-2xl">
              {c.emoji}
            </div>
            <div>
              <h2 className="font-semibold text-ink group-hover:text-brand-700">{t(c.title)}</h2>
              <p className="mt-0.5 text-sm text-ink-faint">{t(c.body)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
